<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>T<span class="smallcaps">HIS ONE</span>’<span class="smallcaps">S FOR YOU</span>, R<span class="smallcaps">EGAN</span>,</span></p>
<p class="ded1"><span><span class="smallcaps">AND FOR</span> G<span class="smallcaps">AIL</span> P<span class="smallcaps">ARIS</span>,</span></p>
<p class="ded1"><span><span class="smallcaps">AND FOR THE MEMBERS OF</span></span></p>
<p class="ded1"><span><span class="smallcaps">THE</span> P<span class="smallcaps">RINCESS OF</span> P<span class="smallcaps">OWER</span> C<span class="smallcaps">LUB</span>.</span></p>
<p class="ded1"><span>M<span class="smallcaps">AY THEIR TIARAS TWINKLE ALL ACROSS THE LAND</span>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?40c41f26